<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <section ref="scrollElement" :class="containerStyles">
    <div
      class="mb-14 grid-cols-12 col-start-2 col-span-12 flex justify-between items-end"
    >
      <header2 v-if="title" :text="title" :is-umbraco="isUmbraco" :theme="themeType" />
    </div>
    <div
      class="grid grid-cols-12 col-start-2 col-span-12 gap-y-10 md:gap-y-32 md:col-start-2 md:col-span-12 md:gap-x-12 2xl:gap-x-20"
    >
      <a
        v-for="(card, index) in pageLinks"
        :class="[
          'flex flex-col group col-span-full',
          index % 2 === 0
            ? 'md:col-start-1 md:col-span-6'
            : 'md:col-start-7 md:col-span-5',
        ]"
        :href="card.url"
        :target="card.target"
      >
        <news-card
          :is-umbraco="isUmbraco"
          :title="card.title"
          :image="card.image"
          :imgAlt="card.imgAlt"
          :theme="theme"
          :index="index"
        />
      </a>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { changeTheme, getThemeType } from "@/util/helper";
import { onIntersect } from "@/composables/onIntersect";
import { computed, toRefs, onMounted, onUnmounted, ref, Ref, onBeforeMount } from "vue";
import { IRelatedPagesProps } from "@/types/components/IRelatedPagesProps";
import Header2 from "@components/Typography/Header2.ce.vue";
import NewsCard from "@molecules/NewsCard/NewsCard.ce.vue";

const observer: Ref<IntersectionObserver | null> = ref(null);
const scrollElement = ref(null);
const isLoading = ref(true);

const props = withDefaults(defineProps<IRelatedPagesProps>(), {
  isUmbraco: false,
  theme: "sand",
});

const { isUmbraco, theme, title, classes, pages } = toRefs(props);

const onEnter = () => {
  if (!theme.value) return;
  changeTheme(theme.value);
};
const onExit = () => {};

onBeforeMount(() => {
  if (theme.value) {
    isLoading.value = false;
  }
});

onMounted(() => {
  if (!isLoading.value) {
    observer.value = onIntersect(scrollElement.value, onEnter, onExit, false, {
      threshold: 0.6,
    });
  }
});

onUnmounted(() => {
  if (!observer.value) return;
  observer.value.disconnect();
});

const containerStyles = computed(() => {
  const bgColor = isUmbraco.value ? `bg-${theme.value}` : ``;
  return `${bgColor} sectionContainer place-content-start py-20 md:py-36 lg:mb-0 ${classes?.value}`;
});

const themeType = computed(() => {
  if (!theme.value) return "dark";
  return getThemeType(theme.value);
});

const pageLinks = computed(() => {
  if (!pages?.value) return [];
  return JSON.parse(pages.value);
});
</script>
